import { useAppSelector } from "../../app/hooks";
import { findProduct } from "../../helpers/reservation";
import { selectHotel } from "../../features/hotel/hotelSlice";
import FormatPrice from "../Helpers/FormatPrice";
interface IProps {
  product: any;
  nightCount: number;
  peopleCount: number;
}

function ProductCard({ product, nightCount, peopleCount }: IProps) {
  const hotel = useAppSelector(selectHotel);
  const hotelProduct = findProduct(product.Id);
  return (
    <div className="flex flex flex-col gap-2 pb-4">
      <div className="flex justify-between text-fluid-base">
        <div>
          {hotelProduct?.Name[hotel.Culture.LanguageCode] ||
            hotelProduct?.Name["en-US"] ||
            ""}
        </div>
        <FormatPrice
          price={
            (hotelProduct?.Prices[hotel.Culture.CurrencyCode] || 1) *
            peopleCount *
            nightCount
          }
        />
      </div>
    </div>
  );
}

export default ProductCard;
